<div
  class="hl-root"
  [style.left.px]="offsetLeft"
  [style.top.px]="offsetTop"
  [style.width.px]="width"
  [style.height.px]="height"
>
  <div
    class="hl-box"
    *ngFor="let b of pxBoxes; trackBy: trackByBox"
    [class.hl-box--row]="b.variant === 'row'"
    [class.hl-box--field]="b.variant === 'field'"
    [class.hl-box--locked]="b.variant === 'locked'"
    [style.left.px]="b.left"
    [style.top.px]="b.top"
    [style.width.px]="b.width"
    [style.height.px]="b.height"
  ></div>
</div>
